<template>
	<div>
		<PageHeader
			:data="{
				name: 'Client Map',
				breadcrumbs: [{ name: 'Home', to: '/' }],
			}"
		/>
		<div class="map-wrapper">
			<h4>Clients MAP</h4>
			<div class="actions mb-3">
				<button class="btn btn-primary" @click="checkMunicipalitiesWithinRadius()">Get List</button>
				<gmap-autocomplete @place_changed="inputLocation" />
				<input type="number" v-model="radius" @input="checkMunicipalitiesWithinRadius()" />
			</div>
			<GmapMap :center="center" :zoom="zoom" map-type-id="terrain" style="width: 100%; height: calc(100vh)">
				<GmapMarker
					:key="index"
					v-for="(m, index) in markers"
					:position="m.position"
					:label="m.population"
					:title="m.title"
					:clickable="true"
					:draggable="false"
					@click="setCenter(m)"
				/>
				<GmapCircle :center="center" :radius="radius * 1609" :strokeColor="'#000'" :fillColor="'transparent'" />
			</GmapMap>
			<h4 class="mt-3">In radius of {{ radius }} miles are {{ areaClients.length }} client</h4>
			<span class="badge badge-primary me-1 mb-1" v-for="(client, i) in areaClients" :key="i"> {{ client.name }} </span>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { gmapApi } from 'vue2-google-maps'

export default {
	name: 'ClientMap',
	components: {
		PageHeader,
	},
	data() {
		return {
			zoom: 4,
			center: { lat: 37.508, lng: -93.587 },
			radius: 50, // In miles
			clients: [],
			markers: [],
			areaClients: [],
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
		google: gmapApi,
	},
	created() {
		this.getClients()
	},
	mounted() {},
	methods: {
		getClients() {
			restApi
				.get('/clients/map', {})
				.then(({ data }) => {
					console.log(data)
					this.clients = data
					this.checkMunicipalitiesWithinRadius()
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error fetching clients MAP data',
						timer: 6000,
					})
				})
		},
		isMunicipalityWithinRadius(municipalityLat, municipalityLng, centerLat, centerLng, radiusMiles) {
			const earthRadiusMiles = 3959 // Radius of the Earth in kilometers
			const dLat = (municipalityLat - centerLat) * (Math.PI / 180)
			const dLng = (municipalityLng - centerLng) * (Math.PI / 180)
			const a =
				Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos(centerLat * (Math.PI / 180)) * Math.cos(municipalityLat * (Math.PI / 180)) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
			const distanceKm = earthRadiusMiles * c

			return distanceKm <= radiusMiles
		},

		checkMunicipalitiesWithinRadius() {
			let municipalitiesList = []
			this.clients.forEach(client => {
				if (this.isMunicipalityWithinRadius(client.latitude, client.longitude, this.center.lat, this.center.lng, this.radius)) {
					municipalitiesList.push(client)
				}
			})
			this.areaClients = municipalitiesList
		},

		inputLocation(place) {
			console.log(place)
			console.log(place.geometry.location.lat())
			console.log(place.geometry.location.lng())
		},

		setCenter(m) {
			this.center = m.position
			this.checkMunicipalitiesWithinRadius()
		},
	},
	watch: {
		clients: function() {
			this.markers = []
			this.clients.forEach(client => {
				let marker = {
					position: { lat: parseFloat(client.latitude), lng: parseFloat(client.longitude) },
					title: client.name,
					population: client.population,
				}
				this.markers.push(marker)
			})
		},
	},
}
</script>

<style scoped>
.vue-map {
	height: 500px;
}
</style>
